export default "__VITE_ASSET__BtoGQOkP__"